import drivingLicenseImg from "../assets/images/Driving-license-image.jpg";
import bankAccountImg from "../assets/images/Bank-Account-image.jpg";
import electricityGasBillImg from "../assets/images/electricity-gas-bill.jpg";
import othersImg from "../assets/images/others-image.jpg";
import aadhaarImage from "../assets/images/aadhar_image.png";
import panImage from "../assets/images/pan-image.png";
import saleDeed from "../assets/images/saledeed.jpg";
import ec from "../assets/images/ec.svg";
import legalOpinion from "../assets/images/legal_opinion.jpg";

export const fileCardTypes = [
  {
    value: "Driving License Front",
    label: "Driving License Front",
    id: "driving_license_front",
    image: drivingLicenseImg,
    disabled: false,
  },
  {
    value: "Driving License Back",
    label: "Driving License Back",
    id: "driving_license_back",
    image: drivingLicenseImg,
    disabled: false,
  },
  {
    value: "Bank Statement 3m",
    label: "Bank Statement 3m",
    id: "bank_statement3",
    image: bankAccountImg,
    disabled: false,
  },
  {
    value: "Bank Statement 6m",
    label: "Bank Statement 6m",
    id: "bank_statement6",
    image: bankAccountImg,
    disabled: false,
  },
  {
    value: "Utility Bill",
    label: "Utility Bill",
    id: "utility_bill",
    image: electricityGasBillImg,
    disabled: false,
  },
  {
    value: "Others",
    label: "Others",
    id: "others",
    image: othersImg,
    disabled: false,
  },
];

export const mlFileCardTypes = [
  ...fileCardTypes,
  {
    value: "Original Sale deed copy",
    label: "Original Sale deed copy",
    id: "original_sale_deed_copy",
    image: saleDeed,
    disabled: false,
  },
  {
    value: "Original Sale deed copy",
    label: "EC",
    id: "ec",
    image: ec,
    disabled: false,
  },
  {
    value: "Original Sale deed copy",
    label: "Legal Opinion",
    id: "legal_opinion",
    image: legalOpinion,
    disabled: false,
  },
];

export const newblFileCardTypes = [
  {
    value: "Aadhaar Front",
    label: "Aadhaar Front",
    id: "aadhaar_front",
    image: aadhaarImage,
    disabled: false,
  },
  {
    value: "Aadhaar Back",
    label: "Aadhaar Back",
    id: "aadhaar_back",
    image: aadhaarImage,
    disabled: false,
  },
  { value: "PAN", label: "PAN", id: "pan", image: panImage, disabled: false },
  {
    value: "Bank Statement 3m",
    label: "Bank Statement 3m",
    id: "bank_statement3",
    image: bankAccountImg,
    disabled: false,
  },
  {
    value: "Bank Statement 6m",
    label: "Bank Statement 6m",
    id: "bank_statement6",
    image: bankAccountImg,
    disabled: false,
  },
  {
    value: "Others",
    label: "Others",
    id: "others",
    image: othersImg,
    disabled: false,
  },
];
